import { useEffect, useState } from 'react';

import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import cx from 'classnames';

import { Button, Icon, Popover } from '@wf/components';

import { getLicenseTypesByCodes, type TLicenseType } from '../../../../services/licenseTypeApiService';

import { Status } from '../../types/enums';

import { licenseStatusSelector, subLicenseTypesSelector } from '../../store/selectors';

import styles from './GenerateButton.module.scss';

function GenerateButton() {
  const { t } = useTranslation();

  const { id: parentId } = useParams();

  const subLicenseTypeCodes = useSelector(subLicenseTypesSelector);
  const status = useSelector(licenseStatusSelector);

  const [subLicenseTypes, setSubLicenseTypes] = useState<TLicenseType[]>([]);

  useEffect(() => {
    if (subLicenseTypeCodes?.length) {
      getLicenseTypesByCodes(subLicenseTypeCodes)
        .then((res) => {
          setSubLicenseTypes(res.data.resultList);
        })
        .catch((e) => console.error(e));
    }
  }, [subLicenseTypeCodes]);

  const showGenerateButton =
    !!subLicenseTypeCodes?.length && (status === Status.APPROVED || status === Status.PARTIALLY_USED);

  return showGenerateButton ? (
    <Popover>
      <Popover.Target>
        {({ isActive }) => (
          <Button rightIcon={<Icon name={isActive ? 'ic_arrow_small_up' : 'ic_arrow_small_down'} />}>
            {t('Generate')}
          </Button>
        )}
      </Popover.Target>
      <Popover.Content className={styles.content}>
        {subLicenseTypes.length
          ? subLicenseTypes.map(({ licenseTypeCode, licenseTypeName }) => (
              <Link
                to={`../../generate?licenseTypeCode=${licenseTypeCode}&parentId=${parentId as string}`}
                className={styles.link}
                key={licenseTypeCode}
                relative="path"
                target="_blank"
              >
                <div className={styles.option}>
                  <div className={cx(styles.title)}>{licenseTypeCode}</div>
                  <div className={styles.description}>{licenseTypeName}</div>
                </div>
              </Link>
            ))
          : subLicenseTypeCodes.map((code) => (
              <Link
                to={`../../generate?licenseTypeCode=${code}&parentId=${parentId as string}`}
                relative="path"
                target="_blank"
                key={code}
              >
                <Button color="typography" ghost>
                  {code}
                </Button>
              </Link>
            ))}
      </Popover.Content>
    </Popover>
  ) : null;
}

export default GenerateButton;
